import './css/styles.scss';

function kontaktSektionInit() {}

kontaktSektionInit();
